import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Blocks staff members from owner/admin-only pages (invoices, team, account,
// establishments). Staff are redirected to their registry.
export function OwnerAdminRoute({ children }) {
  const { partner } = useAuth();
  if (partner && partner.role === "staff") return <Navigate to="/b2b/registry" replace />;
  return children;
}

export default OwnerAdminRoute;
